export default {
    methods: {
        $selectContentLabel(page, label){
            var formLabels = this.$templateDefault(); 
            if (this.$checkNull(page)) {
                switch(page)
                {
                    case 'select_category_blog' :
                    case 'select_category_news':
                        formLabels = {
                                protected:[],
                                flag1: '-1',
                                text: 'Description',
                                text2: '-1',
                                text2En: '-1',
                                image:'-1',
                                order:'Ordre',
                            };                        
                        break;                    
                    case 'select_category_project':
                            formLabels = {
                                protected:[],
                                flag1: '-1',
                                text: 'Description',
                                text2: 'Catégorie',
                                text2En: '-1',
                                image:'-1',
                                order:'Ordre',
                            };                        
                        break;
                    case 'select_heading_project':
                            formLabels = {
                                protected:[],
                                flag1: '-1',
                                text: 'Description',
                                text2: '-1',
                                text2En: '-1',
                                image:'-1',
                                order:'Ordre',
                            };                        
                            break;
                    case 'navigation': 
                        formLabels = {
                            protected: ['page', 'label'],
                            flag1: '-1',
                            text: 'Label navigation',
                            text2En: '-1',
                            text2: '-1',
                            image:'-1',
                            order : '-1'
                        };
                        break;
                    case 'slider_home':
                        formLabels = {
                            protected:[],
                            flag1: 'Texte description bas',
                            text: 'Label navigation',
                            text2: '-1',
                            text2En: '-1',
                            order:'Ordre',
                            text3: 'Description slider',
                            image:'-',
                        };
                        break;
                    case 'studio':
                    case 'contact':
                        switch(label)
                        {
                            case 'image_droite':
                                formLabels = this.$templateImage();
                                break;
                            default:
                                if (label.match(/^meta\_/g))
                                    formLabels = this.$templateMeta();
                                else
                                    formLabels = this.$templateShortContent();
                                break;
                        }
                        break;
                    case 'newsroom':
                        if (label.match(/^meta\_/g))
                            formLabels = this.$templateMeta();
                        else
                            formLabels = this.$templateContent();
                        break;
                    default:
                        if (label.match(/^meta\_/g) || 
                            label == "description_filtre")
                            formLabels = this.$templateMeta();
                        break;
                }
            }
            return formLabels;
        },
        $templateDefault(){
            return{
                protected: [],
                flag1: 'flag 1',
                text: 'Texte',
                text2: 'Texte 2 FR',
                text2En: 'Texte 2 EN',
                order: 'Ordre'
            };            
        },
        $templateImage(){
            return { 
                        protected: ['page', 'label', 'no_html'],
                        flag1: '-1',
                        text: '-1',
                        text2: '-1',
                        text2En: '-1',
                        image:'-',
                        order:'-1',
            };
        },
        $templateMeta(){
            return {
                        protected: ['page', 'label', 'no_html'],
                        flag1: '-1',
                        text: 'Description',
                        text2: '-1',
                        text2En: '-1',
                        image:'-1',
                        order:'-1'
            };
        },
        $templateContent(){
            return {
                        protected: ['page', 'label'],   
                        flag1: '-1',
                        text: 'Description',
                        text2: 'Titre  FR',
                        text2En: 'Titre EN',
                        image:'-1',
                        order:'-1'
                    };
        },        
        $templateShortContent(){
            return {
                        protected: ['page', 'label'],   
                        flag1: '-1',
                        text: 'Description',
                        text2: '-1',
                        text2En: '-1',
                        image:'-1',
                        order:'-1'
                    };
        },        
        
    }
}



// WEBPACK FOOTER //
// ./src/mixins/dyncontent-templates.js